export type LanguageCode =
  | 'de'
  | 'en'
  | 'fr'
  | 'nl'
  | 'cs'
  | 'da'
  | 'hu'
  | 'it'
  | 'pl'
  | 'pt'
  | 'es'
  | 'tr'

export interface Language {
  code: LanguageCode
  name: string
  flag: string
}

export const supportedLanguages: Language[] = [
  { code: 'de', name: 'Deutsch', flag: 'circle-flags:de' },
  { code: 'en', name: 'English', flag: 'circle-flags:gb' },
  { code: 'fr', name: 'Français', flag: 'circle-flags:fr' },
  { code: 'nl', name: 'Dutch', flag: 'circle-flags:nl' },
  { code: 'cs', name: 'Czech', flag: 'circle-flags:cz' },
  { code: 'da', name: 'Danish', flag: 'circle-flags:dk' },
  { code: 'hu', name: 'Hungarian', flag: 'circle-flags:hu' },
  { code: 'it', name: 'Italian', flag: 'circle-flags:it' },
  { code: 'pl', name: 'Polish', flag: 'circle-flags:pl' },
  { code: 'pt', name: 'Portuguese', flag: 'circle-flags:pt' },
  { code: 'es', name: 'Spanish', flag: 'circle-flags:es' },
  { code: 'tr', name: 'Turkish', flag: 'circle-flags:tr' },
]
